import { useState } from "react";
import classNames from "../../classNames";
import Card from "./Card";
import { Progress } from "../../nq-component";

function BankCards({ className, objects, title = false, isLoading, ...props }) {
  const [show, setShow] = useState(true);

  const showToggle = () => {
    setShow((prevState) => !prevState);
  };

  return (
    <>
      <div className="d-flex flex-column gap-2">
        {title && (
          <div
            className="d-flex gap-2 align-self-start rounded-2 align-items-center p-2 border bg-light"
            style={{ cursor: "pointer", transition: "all 0.3s ease" }}
            onClick={showToggle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-0.5px)";
              e.currentTarget.style.boxShadow = "0 3px 5px rgba(0, 0, 0, 0.12)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.12)";
            }}
          >
            <h5 className="fw-medium m-0">Bank Account/s</h5>

            <div className="d-flex">
              <p className="m-0">{"("}</p>
              <p className="m-0 text-success fw-bold">
                {isLoading ? "..." : objects.length}
              </p>
              <p className="m-0">{")"}</p>
            </div>

            <i
              className={`bi bi-eye-${show ? "fill text-success" : "slash-fill text-muted"}`}
            ></i>
          </div>
        )}
      </div>

      <div>
        {isLoading ? (
          <Progress />
        ) : (
          <>
            {objects && objects.length > 0 ? (
              <>
                {show && (
                  <div className={classNames(className, "row g-3")}>
                    {objects.map(
                      ({ id, name, balance, openingBalance, logo }) => (
                        <Card
                          key={id}
                          id={id}
                          name={name}
                          balance={balance || openingBalance}
                          logo={logo}
                          {...props}
                        />
                      ),
                    )}
                  </div>
                )}
              </>
            ) : (
              <div className="py-5 d-flex flex-column align-items-center rounded-2 bg-light">
                <i className="bi bi-bank text-muted fs-2"></i>
                <p className="m-0 fw-medium text-muted">
                  No bank accounts found.
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default BankCards;
